const LOCAL_SERVER_URL = 'http://localhost:8787';

export type AuthTokenProvider = () => string | null | Promise<string | null>;

let tokenAccessor: (() => Promise<string | null>) | null = null;

interface ApiEnv {
  VITE_API_URL?: string;
  PROD?: boolean;
}

export function resolveApiBase(env: ApiEnv, origin?: string): string {
  if (env.VITE_API_URL) {
    return env.VITE_API_URL;
  }
  if (env.PROD && origin) {
    return origin;
  }
  return LOCAL_SERVER_URL;
}

const env = import.meta.env as ApiEnv;
const runtimeOrigin = typeof window !== 'undefined' ? window.location.origin : undefined;
export const API_BASE = resolveApiBase(env, runtimeOrigin);

export function setTokenAccessor(fn: (() => Promise<string | null>) | null): void {
  tokenAccessor = fn;
}

export function setAuthTokenProvider(provider: AuthTokenProvider | null): void {
  tokenAccessor = provider ? async () => provider() : null;
}

export async function apiFetch<T>(path: string, options?: RequestInit): Promise<T> {
  const headers = new Headers(options?.headers);
  if (tokenAccessor && !headers.has('Authorization')) {
    const token = await tokenAccessor();
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
  }

  if (!headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json');
  }

  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    credentials: 'include',
    headers,
  });
  if (!res.ok) {
    const error = await res.json().catch(() => ({ message: res.statusText }));
    throw new Error((error as { message?: string }).message || res.statusText);
  }
  return res.json() as Promise<T>;
}
